import { Injectable } from '@angular/core';
import { LoadingController,ToastController  } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(public toastController: ToastController,public loadingController: LoadingController) { }
  loaderToShow: any;
  toast: any;

  isLoading = false;

  // async showLoader(msg) {
  //   this.loaderToShow = this.loadingController.create({
  //     message: msg
  //   }).then((res) => {
  //      res.present();

  //      res.onDidDismiss().then((dis) => {
  //       console.log('Loading dismissed!');
  //     });
  //   });
  //   //this.hideLoader();
  // }

  async showLoader(msg) {
    this.isLoading = true;
    return await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: msg,
      spinner: 'bubbles',
      translucent:true,
      animated:true,
      showBackdrop:true
    }).then(a => {
      a.present().then(() => {
        console.log('presented');
        if (!this.isLoading) {
          a.dismiss().then(() => console.log('abort presenting'));
        }
      });
    });
  }
  async hideLoader() {
    this.isLoading = false;
    return await this.loadingController.dismiss().then(() => console.log('dismissed'));
  }
  create(msg) {
    this.toast = this.toastController.create({
      message: msg,
      duration: 2000
    }).then((toastData)=>{
      console.log(toastData);
      toastData.present();
    });
  }
  hide(){
    this.toast = this.toastController.dismiss();
  }
}
